import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseSiteService } from '@spartacus/core';
import { take } from 'rxjs/operators';
import { WindowReferenceService } from '../services/window-reference.service';
import { SharedService } from './shared.service';

@Injectable({
  providedIn: 'root'
})

export class DataLayerService {
  private window;
  baseSiteId: any;

  constructor(
    private _windowRef: WindowReferenceService,
    private readonly sharedService: SharedService,
    private baseSiteService: BaseSiteService,
    private readonly activatedRoute: ActivatedRoute) {
    this.window = _windowRef.nativeWindow;
  }

  private pingHome(obj) {
    if (obj) {
      const _win: any = window;
      // for (var i = 0; i < _win.dataLayer.length; i++) {
      //   var event = _win.dataLayer[i];

      //   if (event.event == 'add_to_cart') {

      //   }
      // }
      if (obj.event == 'add_to_cart') {
        if (obj.ecommerce.items[0]?.item_name != undefined) {
          this.window.dataLayer.push(obj);
        }
      }
      // else if (obj.event == 'view_promotion') {
      //   if (obj.ecommerce.items[0].item_name != 'no product related') {
      //     this.window.dataLayer.push(obj);
      //   }
      // }
      else {
        this.window.dataLayer.push(obj);
      }
    }
  }

  logPageView(event) {
    this.pingHome(event);
  }

  decodeHtmlCharCodes(str) {
    if (str != undefined || str != '') {
      str = str?.replace(/<p>/g, '');
      str = str?.replace(/<\/p>/gm, '');
      str = str?.replace(/&trade;/g, '™');
      str = str?.replace(/&lt/g, '<');
      str = str?.replace(/&gt;/g, '>');
      str = str?.replace(/&nbsp;/g, '');
      str = str?.replace(/"/g, '&quot;');
      str = str?.replace(/'/g, '&#039;');
      str = str?.replace(/<sup>&reg;<\/sup>/g, '®');
      str = str?.replace(/<sup>®<\/sup>/g, '®');
      str = str?.replace(/&reg;/g, '®');
      str = str?.replace(/<sup>&trade;<\/sup>/g, '™');
      str = str?.replace(/<sup>™<\/sup>/g, '™');
      str = str?.replace(/<span>/g, '');
      str = str?.replace(/<\/span>/gm, '');
      str = str?.replace(/\n/g, '');
      str = str?.replace(/<br>/g, '');
      str = str?.replace(/&nbsp/g, ' ');
      return str;
    }
  }

  addtoDataLayer(type: any, data: any, locs?, locId?, eventSubType?, stepName?, level?) {
    this.baseSiteService.getActive().pipe(take(1)).subscribe(res => this.baseSiteId = res);
    let obj_dL;
    const _win: any = window;
    switch (type) {
      case "login": {
        obj_dL = {
          "event": "login",
          "user_id": data,
          "interaction_type": "authentication"
        }
        for (var i = 0; i < _win.dataLayer.length; i++) {
          var event = _win.dataLayer[i];
          if (event.event == 'login') {
            _win.dataLayer.splice(i, 1);
          }
        }
        break;
      }

      case "selectProduct": {
        let priceSet;
        if (data?.baseProductInfo?.hasOwnProperty('variantInfo')) {
          if (data?.baseProductInfo?.variantInfo[0]?.hasOwnProperty('priceInfos')) {
            if (data?.baseProductInfo?.variantInfo[0]?.priceInfos?.hasOwnProperty('conditions')) {
              priceSet = data?.baseProductInfo?.variantInfo[0]?.priceInfos?.conditions[0]?.contractPrice;
            }
            else if (data?.baseProductInfo?.variantInfo[0]?.priceInfos.hasOwnProperty('price')) {
              priceSet = data?.baseProductInfo?.variantInfo[0]?.priceInfos.price
            }
          }
          else {
            priceSet = { "value": 0, currencyIso: '' }
          }
        }
        else {
          priceSet = { "value": 0, currencyIso: '' }
        }
        //let priceSet = data?.baseProductInfo?.variantInfo[0]?.priceInfos?.hasOwnProperty('conditions') ? data?.baseProductInfo?.variantInfo[0]?.priceInfos?.conditions[0]?.contractPrice : data?.baseProductInfo?.variantInfo[0]?.priceInfos.price;
        let objArr = [];
        let obj_dL_temp = {
          "item_id": data?.code,
          "item_list_id": data?.code + "-0",
          "item_list_name": "product catalog all products",
          "item_name": locId == 'reorder' ? this.decodeHtmlCharCodes(data?.baseProductName) : this.decodeHtmlCharCodes(data?.name),
          "affiliation": this.baseSiteId === 'vsh' ? 'Vaccineshoppe' : 'Vaxserve',
          "currency": priceSet?.currencyIso != undefined ? priceSet?.currencyIso : 'USD',
          "coupon": "",
          "item_brand": data?.manufacturer,
          "item_category": data?.hasOwnProperty('categoryNameList') ? data?.categoryNameList[0] : '',
          "item_category2": data?.hasOwnProperty('categoryNameList') ? data?.categoryNameList[1] : '',
          "item_variant": locId == 'reorder' ? this.decodeHtmlCharCodes(data?.variantProductDescription) : this.decodeHtmlCharCodes(data?.description),
          "price": priceSet?.value != undefined ? priceSet?.value : 0,
          "quantity": 1,
        }
        let obj = _win.dataLayer.find(o => o.event === 'select_item');
        // if (obj != undefined) {
        //   for (var i = 0; i < _win.dataLayer.length; i++) {
        //     var event = _win.dataLayer[i];
        //     if (event.event == 'select_item') {
        //       event.ecommerce.items.forEach(el => {
        //         objArr.push(el);
        //       })
        //       objArr.push(obj_dL_temp);
        //       _win.dataLayer.splice(i, 1);
        //     }
        //   }
        // }
        // else {
        objArr.push(obj_dL_temp);
        //}
        let tempobj = { "items": objArr };
        obj_dL = {
          "ecommerce": tempobj,
          "interaction_type": "ecommerce",
          "event": "select_item",
          "multiple_locations": locs?.length > 1 ? "yes" : "no",
        }
        break;
      }

      case "view_item_list": {
        let objArr = [];
        let obj_dL_temp;
        let dataContainer;
        if (locId == 'reorder') {
          dataContainer = data;
        }
        else {
          dataContainer = data?.products;
        }
        if (dataContainer?.length > 0) {
          dataContainer?.forEach((el, index) => {
            obj_dL_temp = {
              "item_id": el?.code,
              "item_name": locId == 'reorder' ? this.decodeHtmlCharCodes(el?.baseProductName) : this.decodeHtmlCharCodes(el?.name),
              "affiliation": this.baseSiteId === 'vsh' ? 'vaccineshoppe.com' : 'vaxserve.com',
              "currency": el?.baseProductInfo?.variantInfo[0]?.priceInfos?.hasOwnProperty('conditions') ? el?.baseProductInfo?.variantInfo[0]?.priceInfos?.conditions[0]?.contractPrice?.currencyIso != undefined ? el?.baseProductInfo?.variantInfo[0]?.priceInfos?.conditions[0]?.contractPrice?.currencyIso : 'USD' : el?.baseProductInfo?.variantInfo[0]?.priceInfos?.price?.currencyIso != undefined ? el?.baseProductInfo?.variantInfo[0]?.priceInfos?.price?.currencyIso : 'USD',
              "coupon": "",
              "item_list_id": index + 1,
              "item_list_name": "product catalog all products",
              "item_brand": el?.manufacturer,
              "item_category": el?.hasOwnProperty('categoryNameList') ? el?.categoryNameList[0] : '',
              "item_category2": el?.hasOwnProperty('categoryNameList') ? el?.categoryNameList[1] : '',
              "item_variant": locId == 'reorder' ? this.decodeHtmlCharCodes(el?.variantProductDescription) : this.decodeHtmlCharCodes(el?.baseProductInfo?.variantInfo[0]?.description),
              "price": el?.baseProductInfo?.variantInfo[0]?.priceInfos?.hasOwnProperty('conditions') ? el?.baseProductInfo?.variantInfo[0]?.priceInfos?.conditions[0]?.contractPrice?.value != undefined ? el?.baseProductInfo?.variantInfo[0]?.priceInfos?.conditions[0]?.contractPrice?.value : 0 : el?.baseProductInfo?.variantInfo[0]?.priceInfos?.price?.value != undefined ? el?.baseProductInfo?.variantInfo[0]?.priceInfos?.price?.value : 0,
              "quantity": 1,
            }
            objArr.push(obj_dL_temp);
          })
          for (var i = 0; i < _win.dataLayer.length; i++) {
            var event = _win.dataLayer[i];
            if (event.event == 'view_item' || event.event == 'select_item') {
              _win.dataLayer.splice(i, 1);
            }
            if (event.event == 'view_item_list' && objArr.length == event.ecommerce.items.length) {
              _win.dataLayer.splice(i, 1);
            }
          }
          let tempobj = { "items": objArr }
          obj_dL = {
            "ecommerce": tempobj,
            "interaction_type": "ecommerce",
            "event": "view_item_list",
            "multiple_locations": locs?.length > 1 ? "yes" : "no"
          }
        }

        break;
      }

      case "view_item": {
        //let priceSet = data?.baseProductInfo?.variantInfo[0]?.priceInfos?.hasOwnProperty('conditions') ? data?.baseProductInfo?.variantInfo[0]?.priceInfos?.conditions[0]?.contractPrice : data?.baseProductInfo?.variantInfo[0]?.priceInfos.price;
        let objArr = [];
        let obj_dL_temp = {
          "item_id": data?.code,
          "item_name": this.decodeHtmlCharCodes(data?.baseProductName),
          "affiliation": this.baseSiteId === 'vsh' ? 'Vaccineshoppe' : 'Vaxserve',
          "currency": data?.priceInfos?.conditions && data?.priceInfos?.conditions?.length > 0 ? (data?.priceInfos?.conditions[0]?.contractPrice?.currencyIso != undefined ? data?.priceInfos?.conditions[0]?.contractPrice?.currencyIso : 'USD') : 'USD',
          "coupon": "",
          "item_brand": data?.manufacturer,
          "item_category": data?.hasOwnProperty('categoryNameList') ? data?.categoryNameList[0] : data?.categories[0]?.code,
          "item_category2": data?.hasOwnProperty('categoryNameList') ? data?.categoryNameList[1] : data?.categories[0]?.name,
          "item_variant": this.decodeHtmlCharCodes(data?.description),
          "price": data?.priceInfos?.conditions && data?.priceInfos?.conditions?.length > 0 ? (data?.priceInfos?.conditions[0]?.contractPrice?.value != undefined ? data?.priceInfos?.conditions[0]?.contractPrice?.value : 0) : 0,
          "quantity": 1,
        }
        let obj = _win.dataLayer.find(o => o.event === 'view_item');
        if (obj != undefined) {
          for (var i = 0; i < _win.dataLayer.length; i++) {
            var event = _win.dataLayer[i];
            if (event.event == 'view_item') {
              _win.dataLayer.splice(i, 1);
            }
          }
        }
        objArr.push(obj_dL_temp);
        let tempobj = { "items": objArr };
        obj_dL = {
          "ecommerce": tempobj,
          "interaction_type": "ecommerce",
          "event": "view_item",
          "multiple_locations": locs?.length > 1 ? "yes" : "no"
        }
        break;
      }

      case "accReg": {
        obj_dL = {
          "event": "sign_up",
          "account_id": "",
          "sign_up_type": "new account",
          "interaction_type": "authentication"
        }
        // for (var i = 0; i < _win.dataLayer.length; i++) {
        //   var event = _win.dataLayer[i];
        //   if (event.event == 'sign_up') {
        //     _win.dataLayer.splice(i, 1);
        //   }
        // }
        break;
      }

      case "userReg": {
        obj_dL = {
          "event": "sign_up",
          "account_id": "",
          "sign_up_type": "new user"
        }
        for (var i = 0; i < _win.dataLayer.length; i++) {
          var event = _win.dataLayer[i];
          if (event.event == 'sign_up' && event.sign_up_type == 'new user') {
            _win.dataLayer.splice(i, 1);
          }
        }
        break;
      }

      case "add_to_cart": {
        let contractFilter;
        let PriceValueCondition = locs?.basePrice.value != "0" ? locs?.basePrice?.value : locs?.contractInfo?.contractPrice?.value != 0 ? locs?.contractInfo?.contractPrice?.value : 0;
        let itemsArr = [];
        if (data != undefined) {
          if (data?.baseProductInfo?.variantInfo && data?.baseProductInfo?.variantInfo[0]?.hasOwnProperty('priceInfos')) {
            if (data?.baseProductInfo?.variantInfo[0]?.priceInfos.hasOwnProperty('conditions')) {
              contractFilter = data?.baseProductInfo?.variantInfo[0]?.priceInfos?.conditions[0];
            } else {
              contractFilter = data?.baseProductInfo?.variantInfo[0]?.priceInfos?.price;
            }
            const _win: any = window;
            let obj_dL_temp = {
              "item_id": data?.code,
              "item_name": locId == 'related' ? this.decodeHtmlCharCodes(data?.baseProductName) : this.decodeHtmlCharCodes(data?.name),
              "affiliation": this.baseSiteId === 'vsh' ? 'vaccineshoppe.com' : 'vaxserve.com',
              "currency": locId == 'related' ? (data?.priceInfos ? (data?.priceInfos?.hasOwnProperty('conditions') ? data?.priceInfos?.conditions[0]?.contractPrice?.currencyIso : data?.priceInfos?.price?.currencyIso) : data?.price ? data?.price?.currencyIso : 'USD') : contractFilter?.hasOwnProperty('contractPrice') ? contractFilter?.contractPrice?.currencyIso : contractFilter?.currencyIso,
              "coupon": "",
              "item_brand": data?.manufacturer,
              "item_category": data?.hasOwnProperty('categoryNameList') ? data?.categoryNameList[0] : '',
              "item_category2": data?.hasOwnProperty('categoryNameList') ? data?.categoryNameList[1] : '',
              "item_variant": locId == 'related' ? this.decodeHtmlCharCodes(data?.variantProductDescription) : this.decodeHtmlCharCodes(data?.baseProductInfo?.variantInfo[0]?.description),
              "price": PriceValueCondition,
              "quantity": locs?.quantity,
            }
            itemsArr.push(obj_dL_temp)
            // for (var i = 0; i < _win.dataLayer.length; i++) {
            //   var event = _win.dataLayer[i];
            //   if (event.event != 'add_to_cart') {
            //     // event.ecommerce.items.forEach(el => {
            //     //   itemsArr.push(el);
            //     // })
            //     _win.dataLayer.splice(i, 1);
            //   }
            // }
            let tempobj = {
              "items": itemsArr,
              "location_id": eventSubType
            }
            obj_dL = {
              "ecommerce": tempobj,
              "interaction_type": "ecommerce",
              "event": "add_to_cart",
              "multiple_locations": locs?.selectedLocations?.length > 1 ? "yes" : "no",
              "location_number": locs?.selectedLocations?.length,
              "process_type": "standard_process"
            }
          } else {
            const _win: any = window;
            let obj_dL_temp = {
              "item_id": data?.code,
              "item_name": locId == 'related' ? this.decodeHtmlCharCodes(data?.baseProductName) : this.decodeHtmlCharCodes(data?.name),
              "affiliation": this.baseSiteId === 'vsh' ? 'vaccineshoppe.com' : 'vaxserve.com',
              "currency": locId == 'related' ? (data?.priceInfos ? (data?.priceInfos?.hasOwnProperty('conditions') ? data?.priceInfos?.conditions[0]?.contractPrice?.currencyIso : data?.priceInfos?.price?.currencyIso) : data?.price ? data?.price?.currencyIso : 'USD') : 'USD',
              "coupon": "",
              "item_brand": data?.manufacturer,
              "item_category": data?.hasOwnProperty('categoryNameList') ? data?.categoryNameList[0] : '',
              "item_category2": data?.hasOwnProperty('categoryNameList') ? data?.categoryNameList[1] : '',
              "item_variant": locId == 'related' ? this.decodeHtmlCharCodes(data?.variantProductDescription) : this.decodeHtmlCharCodes(data?.description),
              "price": PriceValueCondition,
              "quantity": locs?.quantity,
            }
            itemsArr.push(obj_dL_temp)
            for (var i = 0; i < _win.dataLayer.length; i++) {
              var event = _win.dataLayer[i];
              // if (event.event == 'add_to_cart') {
              //   // event.ecommerce.items.forEach(el => {
              //   //   itemsArr.push(el);
              //   // })
              //   _win.dataLayer.splice(i, 1);
              // }
            }
            let tempobj = {
              "items": itemsArr,
              "location_id": eventSubType
            }
            obj_dL = {
              "ecommerce": tempobj,
              "interaction_type": "ecommerce",
              "event": "add_to_cart",
              "multiple_locations": locs?.selectedLocations?.length > 1 ? "yes" : "no",
              "location_number": locs?.selectedLocations?.length,
              "process_type": "standard_process"
            }
          }
        }
        break;
      }
      case "add_to_cart_Orders": {
        let contractFilter;
        let itemsArr = [];
        if (data != undefined) {
          if (!data?.baseProductInfo?.variantInfo[0]?.hasOwnProperty('priceInfos')) {

            const _win: any = window;
            let obj_dL_temp = {
              "item_id": data?.item_id,
              "item_name": this.decodeHtmlCharCodes(data?.item_name),
              "affiliation": this.baseSiteId === 'vsh' ? 'vaccineshoppe.com' : 'vaxserve.com',
              "currency": data?.currency,
              "coupon": "",
              "item_brand": data?.item_brand,
              "item_category": data?.hasOwnProperty('categoryNameList') ? data?.categoryNameList[0] : '',
              "item_category2": data?.hasOwnProperty('categoryNameList') ? data?.categoryNameList[1] : '',
              "item_variant": this.decodeHtmlCharCodes(data?.item_variant),
              "price": data?.price,
              "quantity": data?.quantity,
            }
            itemsArr.push(obj_dL_temp)
            for (var i = 0; i < _win.dataLayer.length; i++) {
              var event = _win.dataLayer[i];
              if (event.event == 'add_to_cart' && event.location_id == locs && event.item_name == data?.item_name) {
                // event.ecommerce.items.forEach(el => {
                //   itemsArr.push(el);
                // })
                _win.dataLayer.splice(i, 1);
              }
            }
            let tempobj = {
              "items": itemsArr,
              "location_id": locs
            }
            obj_dL = {
              "ecommerce": tempobj,
              "interaction_type": "ecommerce",
              "event": "add_to_cart",
              "multiple_locations": locId?.length > 1 ? "yes" : "no",
              "location_number": locId?.length,
              "process_type": "standard_process"
            }
          }
          // else {
          //   const _win: any = window;
          //   let obj_dL_temp = {
          //     "item_id": data?.code,
          //     "item_name": data?.name,
          //     "affiliation": this.baseSiteId === 'vsh' ? 'vaccineshoppe.com' : 'vaxserve.com',
          //     "currency": "USD",
          //     "coupon": "",
          //     "item_brand": data?.manufacturer,
          //     "item_category": data?.hasOwnProperty('categoryNameList') ? data?.categoryNameList[0] : '',
          //     "item_category2": data?.hasOwnProperty('categoryNameList') ? data?.categoryNameList[1] : '',
          //     "item_variant": this.decodeHtmlCharCodes(data?.description),
          //     "price": locs?.basePrice?.value,
          //     "quantity": locs?.quantity,
          //   }
          //   itemsArr.push(obj_dL_temp)
          //   for (var i = 0; i < _win.dataLayer.length; i++) {
          //     var event = _win.dataLayer[i];
          //     // if (event.event == 'add_to_cart') {
          //     //   // event.ecommerce.items.forEach(el => {
          //     //   //   itemsArr.push(el);
          //     //   // })
          //     //   _win.dataLayer.splice(i, 1);
          //     // }
          //   }
          //   let tempobj = {
          //     "items": itemsArr,
          //     "location_id": locId
          //   }
          //   obj_dL = {
          //     "ecommerce": tempobj,
          //     "interaction_type": "ecommerce",
          //     "event": "add_to_cart",
          //     "multiple_locations": locs?.selectedLocations?.length > 1 ? "yes" : "no",
          //     "location_number": locs?.selectedLocations?.length,
          //     "process_type": "standard_process"
          //   }

          // }
        }
        break;
      }

      case "add_to_cart_OrderDetails": {
        let contractFilter;
        let itemsArr = [];
        if (data != undefined) {

          const _win: any = window;
          data?.forEach(el => {
            let obj_dL_temp = {
              "item_id": el?.product?.code,
              "item_name": this.decodeHtmlCharCodes(el?.product?.baseProductName),
              "affiliation": this.baseSiteId === 'vsh' ? 'vaccineshoppe.com' : 'vaxserve.com',
              "currency": el?.totalPrice?.currencyIso,
              "coupon": "",
              "item_brand": el?.product?.manufacturer,
              "item_category": el?.product?.hasOwnProperty('categoryNameList') ? el?.product?.categoryNameList[0] : '',
              "item_category2": el?.product?.hasOwnProperty('categoryNameList') ? el?.product?.categoryNameList[1] : '',
              "item_variant": this.decodeHtmlCharCodes(el?.product?.description),
              "price": el?.totalPrice?.value,
              "quantity": el?.quantity,
            }
            itemsArr.push(obj_dL_temp)
          })

          for (var i = 0; i < _win.dataLayer.length; i++) {
            var event = _win.dataLayer[i];
            // if (event.event == 'add_to_cart') {
            //   // event.ecommerce.items.forEach(el => {
            //   //   itemsArr.push(el);
            //   // })
            //   _win.dataLayer.splice(i, 1);
            // }
          }
          let tempobj = {
            "items": itemsArr,
            "location_id": locs?.accountNumber
          }
          obj_dL = {
            "ecommerce": tempobj,
            "interaction_type": "ecommerce",
            "event": "add_to_cart",
            "multiple_locations": locId.length > 1 ? "yes" : "no",
            "location_number": locId.length,
            "process_type": "standard_process"
          }


        }
        break;
      }

      case "add_to_cart_Flu": {
        for (var i = 0; i < _win.dataLayer.length; i++) {
          var event = _win.dataLayer[i];
          // if (event.event == 'add_to_cart') {
          //   // event.ecommerce.items.forEach(el => {
          //   //   itemsArr.push(el);
          //   // })
          //   _win.dataLayer.splice(i, 1);
          // }
        }
        let contractFilter;
        let itemsArr = [];
        if (data != undefined) {

          const _win: any = window;
          data?.forEach((el, index) => {

            //if (this.activatedRoute.snapshot.queryParams.editReservation == 'yes') {
            if (el?.productQuantityValue > 0) {

              let obj_dL_temp = {
                "item_id": el?.code,
                "item_name": this.decodeHtmlCharCodes(el?.baseProductName),
                "affiliation": this.baseSiteId === 'vsh' ? 'vaccineshoppe.com' : 'vaxserve.com',
                // "currency": el?.conditions[0]?.contractPrice?.currencyIso,
                "currency": el?.conditions ? el?.conditions[0]?.contractPrice?.currencyIso : el?.price?.currencyIso,
                "coupon": "",
                "item_brand": el?.manufacturer,
                "item_category": el?.product?.hasOwnProperty('categoryNameList') ? el?.product?.categoryNameList[0] : el?.categories[0]?.name,
                "item_category2": el?.product?.hasOwnProperty('categoryNameList') ? el?.product?.categoryNameList[1] : el?.categories[0]?.code,
                "item_variant": this.decodeHtmlCharCodes(el?.description),
                // "price": el?.conditions[0]?.contractPrice?.value,
                "price": el?.conditions ? el?.conditions[0]?.contractPrice?.value : el.price?.value,
                "quantity": el?.productQuantityValue,
              }
              itemsArr.push(obj_dL_temp);

            }


            // }
            // else {
            //   let obj_dL_temp = {
            //     "item_id": el?.product?.code,
            //     "item_name": this.decodeHtmlCharCodes(el?.product?.baseProductName),
            //     "affiliation": this.baseSiteId === 'vsh' ? 'vaccineshoppe.com' : 'vaxserve.com',
            //     "currency": el?.totalPrice?.currencyIso,
            //     "coupon": "",
            //     "item_brand": el?.product?.manufacturer,
            //     "item_category": el?.product?.hasOwnProperty('categoryNameList') ? el?.product?.categoryNameList[0] : '',
            //     "item_category2": el?.product?.hasOwnProperty('categoryNameList') ? el?.product?.categoryNameList[1] : '',
            //     "item_variant": this.decodeHtmlCharCodes(el?.product?.description),
            //     "price": el?.totalPrice?.value,
            //     "quantity": el?.quantity,
            //   }
            //   itemsArr.push(obj_dL_temp);
            // }

          })

          for (var i = 0; i < _win.dataLayer.length; i++) {
            var event = _win.dataLayer[i];
            // if (event.event == 'add_to_cart') {
            //   // event.ecommerce.items.forEach(el => {
            //   //   itemsArr.push(el);
            //   // })
            //   _win.dataLayer.splice(i, 1);
            // }
          }
          let tempobj = {
            "items": itemsArr,
            "location_id": locs
          }
          obj_dL = {
            "ecommerce": tempobj,
            "interaction_type": "ecommerce",
            "event": "add_to_cart",
            "multiple_locations": "no",
            "location_number": 1,
            "process_type": this.activatedRoute.snapshot.queryParams.editReservation ? "edit reservation" : "new reservation"
          }


        }
        break;
      }

      case "add_to_cart_SavedOrders": {
        //debugger
        let contractFilter;
        let obj_dL_temp;
        let itemsArr = [];
        if (data != undefined) {
          //if (!data?.baseProductInfo?.variantInfo[0]?.hasOwnProperty('priceInfos')) {
          const _win: any = window;
          data?.forEach(element => {
            obj_dL_temp = {
              "item_id": element?.product?.code,
              "item_name": this.decodeHtmlCharCodes(element?.product?.baseProductName),
              "affiliation": this.baseSiteId === 'vsh' ? 'vaccineshoppe.com' : 'vaxserve.com',
              "currency": element?.totalPrice?.currencyIso,
              "coupon": "",
              "item_brand": element?.product?.manufacturer,
              "item_category": element?.product?.hasOwnProperty('categoryNameList') ? element?.product?.categoryNameList[0] : '',
              "item_category2": element?.product?.hasOwnProperty('categoryNameList') ? element?.product?.categoryNameList[1] : '',
              "item_variant": this.decodeHtmlCharCodes(element?.product?.description),
              "price": element?.totalPrice?.value,
              "quantity": element?.quantity,
            }
            itemsArr.push(obj_dL_temp)
          })


          let tempobj = {
            "items": itemsArr,
            "location_id": locs
          }
          obj_dL = {
            "ecommerce": tempobj,
            "interaction_type": "ecommerce",
            "event": "add_to_cart",
            "multiple_locations": locId?.length > 1 ? "yes" : "no",
            "location_number": locId?.length,
            "process_type": "standard_process"
          }
          //} 
          // else {
          //   const _win: any = window;
          //   let obj_dL_temp = {
          //     "item_id": data?.code,
          //     "item_name": data?.name,
          //     "affiliation": this.baseSiteId === 'vsh' ? 'vaccineshoppe.com' : 'vaxserve.com',
          //     "currency": "USD",
          //     "coupon": "",
          //     "item_brand": data?.manufacturer,
          //     "item_category": data?.hasOwnProperty('categoryNameList') ? data?.categoryNameList[0] : '',
          //     "item_category2": data?.hasOwnProperty('categoryNameList') ? data?.categoryNameList[1] : '',
          //     "item_variant": this.decodeHtmlCharCodes(data?.description),
          //     "price": locs?.basePrice?.value,
          //     "quantity": locs?.quantity,
          //   }
          //   itemsArr.push(obj_dL_temp)
          //   for (var i = 0; i < _win.dataLayer.length; i++) {
          //     var event = _win.dataLayer[i];
          //     // if (event.event == 'add_to_cart') {
          //     //   // event.ecommerce.items.forEach(el => {
          //     //   //   itemsArr.push(el);
          //     //   // })
          //     //   _win.dataLayer.splice(i, 1);
          //     // }
          //   }
          //   let tempobj = {
          //     "items": itemsArr,
          //     "location_id": locId
          //   }
          //   obj_dL = {
          //     "ecommerce": tempobj,
          //     "interaction_type": "ecommerce",
          //     "event": "add_to_cart",
          //     "multiple_locations": locs?.selectedLocations?.length > 1 ? "yes" : "no",
          //     "location_number": locs?.selectedLocations?.length,
          //     "process_type": "standard_process"
          //   }

          // }
        }
        break;
      }

      case "upload_order": {
        let contractFilter;
        let itemsArr = [];
        if (data != undefined) {
          // if (data?.baseProductInfo?.variantInfo[0]?.hasOwnProperty('priceInfos')) {
          //contractFilter = data?.baseProductInfo?.variantInfo[0]?.priceInfos?.price;

          const _win: any = window;
          let obj_dL_temp;

          data.forEach((element, index) => {
            obj_dL_temp = {
              "item_id": data[index]?.value?.code,
              "item_name": this.decodeHtmlCharCodes(data[index]?.value?.baseProductName),
              "affiliation": this.baseSiteId === 'vsh' ? 'vaccineshoppe.com' : 'vaxserve.com',
              "currency": "USD",
              "coupon": "",
              "item_brand": data[index]?.value?.manufacturer,
              "item_category": "",
              "item_category2": "",
              "item_variant": data[index]?.value?.variantProductDescription,
              "price": 0,
              "quantity": data[index]?.quantity,
            }
            itemsArr.push(obj_dL_temp)
          });


          for (var i = 0; i < _win.dataLayer.length; i++) {
            var event = _win.dataLayer[i];
          }
          let tempobj = {
            "items": itemsArr,
            "location_id": locId
          }
          obj_dL = {
            "ecommerce": tempobj,
            "interaction_type": "ecommerce",
            "event": "upload_order",
            "multiple_locations": locs?.length > 1 ? "yes" : "no",
            "location_number": locs?.length,
            "process_type": "standard_process"
          }


        }
        else {
          const _win: any = window;
          let obj_dL_temp = {
            "item_id": data?.code,
            "item_name": DataTransferItem?.name,
            "affiliation": this.baseSiteId === 'vsh' ? 'vaccineshoppe.com' : 'vaxserve.com',
            "currency": "",
            "coupon": "",
            "item_brand": data?.manufacturer,
            "item_category": data?.baseProductDescription,
            "item_category2": "",
            "item_variant": data?.hasOwnProperty('baseProductInfo') ? data?.baseProductInfo?.variantInfo : '',
            "price": "",
            "quantity": "",
          }
          itemsArr.push(obj_dL_temp)
          for (var i = 0; i < _win.dataLayer.length; i++) {
            var event = _win.dataLayer[i];
          }
          let tempobj = {
            "items": itemsArr,
            "location_id": locId
          }
          obj_dL = {
            "ecommerce": tempobj,
            "interaction_type": "ecommerce",
            "event": "upload_order",
            "multiple_locations": locs?.length > 1 ? "yes" : "no",
            "location_number": locs?.length,
            "process_type": "standard_process"
          }
        }

        break;
      }

      case "purchase": {
        for (var i = 0; i < _win.dataLayer.length; i++) {
          var event = _win.dataLayer[i];
          if (event.event == 'purchase') {
            // event.ecommerce.items.forEach(el => {
            //   itemsArr.push(el);
            // })
            _win.dataLayer.splice(i, 1);
          }
        }
        var processType;
        if (data?.orderFullData?.cartType == "STANDARD") {
          processType = "standard_process";
        }
        else {
          if (this.activatedRoute.snapshot.queryParams.editReservation) {
            processType = "edit reservation";
          }
          else {
            processType = "new reservation";
          }
        }


        let obj_dL_temp = {
          "transaction_id": data?.orderFullData?.code,
          "location_id": data?.orderFullData?.shipToLoc_id,
          "affiliation": data?.orderFullData?.cartType == "STANDARD" ? 'order products' : 'influenza products',
          "value": data?.orderFullData?.totalPrice?.value,
          "tax": data?.orderFullData?.totalExciseTax?.value,
          "coupon": "",
          "currency": "USD",
          "items": data?.datalayerList,
          "shipping": data?.orderFullData?.shipToLoc_name,
        }
        obj_dL = {
          "event": "purchase",
          "interaction_type": "ecommerce",
          "process_type": processType,
          "multiple_locations": locs?.length > 1 ? "yes" : "no",
          "location_number": locs?.length,
          "ecommerce": obj_dL_temp
        }
        break;
      }

      case "view_cart": {
        let itemsArr = [];
        if (data != undefined) {
          const _win: any = window;
          data?.entries?.forEach(el => {
            let obj_dL_temp = {
              "item_id": el?.product?.code,
              "item_name": this.decodeHtmlCharCodes(el?.product?.baseProductName),
              "affiliation": data?.cartType == "STANDARD" ? 'order products' : 'influenza products',
              "currency": el?.product?.conditions ? el?.product?.conditions[0]?.contractPrice?.currencyIso : el?.product?.price?.currencyIso,
              "discount": data?.totalDiscounts?.value,
              "index": el?.entryNumber,
              "item_brand": el?.product?.manufacturer,
              "item_category": this.decodeHtmlCharCodes(el?.product?.baseProductInfo?.baseProductDescription),
              "item_category2": el?.product?.url,
              "item_variant": this.decodeHtmlCharCodes(el?.product?.variantProductDescription),
              "price": el?.product?.conditions ? el?.product?.conditions[0]?.contractPrice?.value : el?.product?.price?.value,
              "quantity": el?.quantity,
            }
            itemsArr.push(obj_dL_temp)
          });
          for (var i = 0; i < _win.dataLayer.length; i++) {
            var event = _win.dataLayer[i];
          }
          let tempobj = {
            "currency": data?.subTotal?.currencyIso,
            "value": data?.subTotal?.value,
            "items": itemsArr,
            "location_id": locs
          }
          obj_dL = {
            "event": 'view_cart',
            "interaction_type": "ecommerce",
            "ecommerce": tempobj,
            "multiple_locations": locId > 1 ? "yes" : "no",
            "location_number": locId,
            "process_type": "standard_process"
          }
        }
        break;
      }

      case "view_cart_reservation": {
        let itemsArr = [];
        if (data != undefined) {
          const _win: any = window;
          data?.entries?.forEach(el => {
            let obj_dL_temp = {
              "item_id": el?.product?.code,
              "item_name": this.decodeHtmlCharCodes(el?.product?.baseProductName),
              "affiliation": data?.cartType == "STANDARD" ? 'order products' : 'influenza products',
              "currency": el?.product?.conditions ? el?.product?.conditions[0]?.contractPrice?.currencyIso : el?.product?.price?.currencyIso,
              "discount": data?.totalDiscounts?.value,
              "index": el?.entryNumber,
              "item_brand": el?.product?.manufacturer,
              "item_category": this.decodeHtmlCharCodes(el?.product?.baseProductInfo?.baseProductDescription),
              "item_category2": el?.product?.url,
              "item_variant": this.decodeHtmlCharCodes(el?.product?.variantProductDescription),
              "price": el?.product?.conditions ? el?.product?.conditions[0]?.contractPrice?.value : el?.product?.price?.value,
              "quantity": el?.quantity,
            }
            itemsArr.push(obj_dL_temp)
          });
          for (var i = 0; i < _win.dataLayer.length; i++) {
            var event = _win.dataLayer[i];
          }
          let tempobj = {
            "currency": data?.totalWithPromptPayDiscount?.currencyIso,
            "value": data?.totalWithPromptPayDiscount?.value,
            "items": itemsArr,
            "location_id": locs
          }
          obj_dL = {
            "event": 'view_cart',
            "interaction_type": "ecommerce",
            "ecommerce": tempobj,
            "multiple_locations": locId > 1 ? "yes" : "no",
            "location_number": locId,
            "process_type": this.activatedRoute.snapshot.queryParams.editReservation ? "edit reservation" : "new reservation"
          }
        }
        break;
      }

      case "view_item_list_related": {
        let objArr = [];
        let obj_dL_temp;
        data?.forEach((el, index) => {
          obj_dL_temp = {
            "item_id": el?.code,
            "item_name": el?.baseProductName ? this.decodeHtmlCharCodes(el?.baseProductName) : this.decodeHtmlCharCodes(el?.name),
            "affiliation": this.baseSiteId === 'vsh' ? 'vaccineshoppe.com' : 'vaxserve.com',
            "currency": el?.priceInfos ? (el?.priceInfos?.hasOwnProperty('conditions') ? el?.priceInfos?.conditions[0]?.contractPrice?.currencyIso : el?.priceInfos?.price?.currencyIso) : el?.price?.currencyIso,
            "coupon": "",
            "item_list_id": index + 1,
            "item_list_name": "product catalog all products",
            "item_brand": el?.manufacturer,
            "item_category": '',
            "item_category2": "",
            "item_variant": el?.baseProductInfo?.variantInfo ? el?.baseProductInfo?.variantInfo : this.decodeHtmlCharCodes(el?.variantProductDescription),
            "price": el?.priceInfos ? (el?.priceInfos?.hasOwnProperty('conditions') ? el?.priceInfos?.conditions[0]?.contractPrice?.value : el?.priceInfos?.price?.value) : el?.price?.value,
            "quantity": 1,
          }
          objArr.push(obj_dL_temp);
        })
        let tempobj = { "items": objArr }
        obj_dL = {
          "ecommerce": tempobj,
          "interaction_type": "ecommerce",
          "event": "view_item_list",
          "multiple_locations": locs?.length > 1 ? "yes" : "no"
        }
        break;
      }

      case "begin_checkout": {
        let itemsArr = [];
        let obj_dL_temp;
        // for (var i = 0; i < _win.dataLayer.length; i++) {
        //   var event = _win.dataLayer[i];
        //   if (event.event == 'begin_checkout' && event.ecommerce.location_id == locs) {
        //     _win.dataLayer.splice(i, 1);
        //   }
        // }
        if (data != undefined) {
          data?.forEach(el => {
            let varDesc = el?.product?.variantOptions?.filter((element) => element?.code === el?.product?.code)
            obj_dL_temp = {
              "item_id": el.product?.code,
              "item_name": this.decodeHtmlCharCodes(el.product?.name),
              "affiliation": this.baseSiteId === 'vsh' ? 'vaccineshoppe.com' : 'vaxserve.com',
              "currency": el?.basePrice?.currencyIso,
              "coupon": '',
              "item_brand": el?.product?.manufacturer,
              "item_category": '',
              "item_category2": '',
              // "item_variant": varDesc[0].description != undefined ? this.decodeHtmlCharCodes(varDesc[0].description) : '',
              "item_variant": varDesc && varDesc?.length > 0 ? (varDesc[0]?.description != undefined ? this.decodeHtmlCharCodes(varDesc[0].description) : '') : '',
              "price": el?.basePrice?.value,
              "quantity": el?.quantity,
            }
            itemsArr.push(obj_dL_temp)
          })

          let tempobj = { "items": itemsArr, "location_id": locs }
          obj_dL = {
            "ecommerce": tempobj,
            "interaction_type": "ecommerce",
            "event": "begin_checkout",
            "multiple_locations": locId > 1 ? "yes" : "no",
            "location_number": locId,
            "process_type": "standard_process"
          }
        }
        break;
      }

      case "flu_checkout": {
        let itemsArr = [];
        let obj_dL_temp;
        if (data != undefined) {
          for (var i = 0; i < _win.dataLayer.length; i++) {
            var event = _win.dataLayer[i];
            if (event.event == 'begin_checkout' && event.ecommerce.location_id == locs) {
              _win.dataLayer.splice(i, 1);
            }
          }
          data.entries.forEach(el => {
            let varDesc = el?.product?.variantOptions.filter((element) => element?.code === el?.product?.code)
            obj_dL_temp = {
              "item_id": el?.product?.code,
              "item_name": this.decodeHtmlCharCodes(el?.product?.name),
              "affiliation": this.baseSiteId === 'vsh' ? 'vaccineshoppe.com' : 'vaxserve.com',
              "currency": el?.product?.price?.currencyIso != undefined ? el?.product?.price?.currencyIso : 'USD',
              "coupon": "",
              "item_brand": el?.product?.manufacturer,
              "item_category": el?.product?.baseProductInfo?.baseProductDescription,
              "item_category2": "",
              "item_variant": varDesc[0].description != undefined ? this.decodeHtmlCharCodes(varDesc[0].description) : '',
              "price": el?.basePrice?.value,
              "quantity": el?.quantity,
            }
            itemsArr.push(obj_dL_temp)
          });
          let tempobj = { "items": itemsArr, "location_id": locs }
          obj_dL = {
            "ecommerce": tempobj,
            "interaction_type": "ecommerce",
            "event": "begin_checkout",
            "multiple_locations": locId > 1 ? "yes" : "no",
            "location_number": locId,
            "process_type": this.activatedRoute.snapshot.queryParams.editReservation ? "edit reservation" : "new reservation"
          }
        }
        break;
      }

      case "view_promotion": {
        let itemArr = [];
        // for (var i = 0; i < _win.dataLayer.length; i++) {
        //   var event = _win.dataLayer[i];
        //   if (event.event == 'view_promotion') {
        //     _win.dataLayer.splice(i, 1);
        //   }
        // }
        if (data?.promoProductId && data?.promoProductName) {
          itemArr = [{ item_id: data?.promoProductId, item_name: data?.promoProductName }];
        } else {
          itemArr = [{ item_name: 'no product related' }];
        }
        obj_dL = {
          "creative_name": "",
          "creative_slot": data?.creativeSlot ? data?.creativeSlot?.toLowerCase() : "staticsquarebanner",
          "ecommerce": {
            "items": itemArr
          },
          "event": 'view_promotion',
          "interaction_type": "ecommerce",
          "promotion_id": data?.uid,
          "promotion_name": data?.name.toLowerCase()
        }
        if (data?.media?.widescreen?.altText) {
          obj_dL.creative_name = data?.media?.widescreen?.altText?.toLowerCase();
        } else if (data?.media?.altText) {
          obj_dL.creative_name = data?.media?.altText?.toLowerCase();
        }
        break;
      }

      case "select_promotion": {
        let itemArr = []
        if (data?.promoProductId && data?.promoProductName) {
          itemArr = [{ item_id: data?.promoProductId, item_name: data?.promoProductName }];
        } else {
          itemArr = [{ item_name: 'no product related' }];
        }
        obj_dL = {
          "creative_name": data?.media?.widescreen ? data?.media?.widescreen?.altText?.toLowerCase() : data?.media?.altText?.toLowerCase(),
          "creative_slot": data?.creativeSlot ? data?.creativeSlot?.toLowerCase() : "staticsquarebanner",
          "ecommerce": {
            "items": itemArr
          },
          "event": 'select_promotion',
          "interaction_type": "ecommerce",
          "promotion_id": data?.uid,
          "promotion_name": data?.name.toLowerCase()
        }
        if (data?.media?.widescreen?.altText) {
          obj_dL.creative_name = data?.media?.widescreen?.altText?.toLowerCase();
        } else if (data?.media?.altText) {
          obj_dL.creative_name = data?.media?.altText?.toLowerCase();
        }
        break;
      }

      case "accReg_FormEvent": {
        obj_dL = {
          "interaction_type": "form",
          "length": "4",
          "name": "Account Registration",
        }
        obj_dL["event"] = eventSubType;
        if (stepName == 'shipping') {
          obj_dL['step_name'] = 'Shipping Details';
          obj_dL['step_number'] = "1";

        } else if (stepName == 'billing') {
          obj_dL['step_name'] = 'Billing Details';
          obj_dL['step_number'] = "2";
          for (var i = 0; i < _win.dataLayer.length; i++) {
            var event = _win.dataLayer[i];
            if (event.event == 'form_start') {
              _win.dataLayer.splice(i, 1);
            }
          }
        }
        else if (stepName == 'license') {
          obj_dL['step_name'] = 'License Details';
          obj_dL['step_number'] = "3";
        }
        else if (stepName == 'confirmation') {
          obj_dL['step_name'] = 'Confirmation Details';
          obj_dL['step_number'] = "4";
        }
        if (eventSubType.includes('error'))
          obj_dL['error_type'] = level === 'tab' ? 'Please correct the errors below' : 'Error'

        for (var i = 0; i < _win.dataLayer.length; i++) {
          var event = _win.dataLayer[i];
          if (event.event == eventSubType) {
            _win.dataLayer.splice(i, 1);
          }
        }
        break;
      }

      case "add_to_cart_futureship": {
        let contractFilter;
        let itemsArr = [];
        if (data != undefined && data.length > 0) {
          const _win: any = window;
          data.forEach(data => {
            let obj_dL_temp = {
              "item_id": data?.product?.code,
              "item_name": this.decodeHtmlCharCodes(data?.product?.name),
              "affiliation": this.baseSiteId === 'vsh' ? 'vaccineshoppe.com' : 'vaxserve.com',
              "currency": data?.product?.priceInfos?.price?.currencyIso,
              "coupon": "",
              "item_brand": data?.product?.manufacturer,
              "item_category": data?.hasOwnProperty('categoryNameList') ? data?.categoryNameList[0] : '',
              "item_category2": data?.hasOwnProperty('categoryNameList') ? data?.categoryNameList[1] : '',
              "item_variant": this.decodeHtmlCharCodes(data?.product?.baseProductDescription),
              "price": data?.product?.priceInfos?.price?.value,
              "quantity": data?.quantity,
            }
            itemsArr.push(obj_dL_temp);
          });
          for (var i = 0; i < _win.dataLayer.length; i++) {
            var event = _win.dataLayer[i];
            if (event.event == 'add_to_cart') {
              // event.ecommerce.items.forEach(el => {
              //   itemsArr.push(el);
              // })
              _win.dataLayer.splice(i, 1);
            }
          }
          let tempobj = {
            "items": itemsArr,
            "location_id": locId
          }
          obj_dL = {
            "ecommerce": tempobj,
            "interaction_type": "ecommerce",
            "event": "add_to_cart",
            "multiple_locations": "no",
            "location_number": locId,
            "process_type": "standard_process"
          }

        }
        break;
      }
      case "selectProduct_reorder": {
        let objArr = [];
        let obj_dL_temp = {
          "item_id": data?.code,
          "item_list_id": data?.code + "-0",
          "item_list_name": "product catalog all products",
          "item_name": this.decodeHtmlCharCodes(data?.baseProductName),
          "affiliation": this.baseSiteId === 'vsh' ? 'Vaccineshoppe' : 'Vaxserve',
          "currency": 'USD',
          "coupon": "",
          "item_brand": data?.manufacturer,
          "item_category": data?.hasOwnProperty('categoryNameList') ? data?.categoryNameList[0] : '',
          "item_category2": data?.hasOwnProperty('categoryNameList') ? data?.categoryNameList[1] : '',
          "item_variant": this.decodeHtmlCharCodes(data?.variantProductDescription),
          "price": 0,
          "quantity": 1,
        }
        let obj = _win.dataLayer.find(o => o.event === 'select_item');
        // if (obj != undefined) {
        //   for (var i = 0; i < _win.dataLayer.length; i++) {
        //     var event = _win.dataLayer[i];
        //     if (event.event == 'select_item') {
        //       event.ecommerce.items.forEach(el => {
        //         objArr.push(el);
        //       })
        //       objArr.push(obj_dL_temp);
        //       _win.dataLayer.splice(i, 1);
        //     }
        //   }
        // }
        // else {
        objArr.push(obj_dL_temp);
        //}
        let tempobj = { "items": objArr };
        obj_dL = {
          "ecommerce": tempobj,
          "interaction_type": "ecommerce",
          "event": "select_item",
          "multiple_locations": locs?.length > 1 ? "yes" : "no",
        }
        break;
      }
      case "OTP_MFA": {
        obj_dL = data;
        break;
      }
      case "profile_MFA": {
        obj_dL = {
          'event': `update_profile_information_${data.step}`,
          'interaction_type': 'account',
          'section': data.section,
          'process_type': data.process
        }
        break
      }
      case "userReg_FormEvent": {
        obj_dL = {
          "interaction_type": "form",
          "length": "3",
          "name": "User Registration",
        }
        obj_dL["event"] = eventSubType;
        if (stepName == 'account') {
          obj_dL['step_name'] = 'Account Information';
          obj_dL['step_number'] = "1";
        } else if (stepName == 'user') {
          obj_dL['step_name'] = 'User Information';
          obj_dL['step_number'] = "2";
        }
        else if (stepName == 'confirmation') {
          obj_dL['step_name'] = 'Confirmation';
          obj_dL['step_number'] = "3";
        }
        if (eventSubType.includes('error'))
          obj_dL['error_type'] = level === 'tab' ? 'Please correct the errors below' : 'Error'

        for (var i = 0; i < _win.dataLayer.length; i++) {
          var event = _win.dataLayer[i];
          if (event.event == eventSubType) {
            _win.dataLayer.splice(i, 1);
          }
        }
        break;
      }

      case "clearDataLayer": {
        obj_dL = { ecommerce: null }
        break;
      }

      case "payAtTerm_FormEvent": {
        obj_dL = {
          "interaction_type": "form",
          "length": "3",
          "name": "make a payment - pay at terms",
        }
        obj_dL["event"] = eventSubType;
        if (stepName == 'payatterms') {
          obj_dL['step_name'] = 'Pay at terms';
          obj_dL['step_number'] = "1";
          if (data?.originalInvoice) {
            obj_dL['invoice_number'] = data?.originalInvoice;
            obj_dL['amount'] = data?.payTxtAmnt;
          }
        } else if (stepName == 'review') {
          obj_dL['step_name'] = 'Review';
          obj_dL['step_number'] = "2";
          if (data?.originalInvoice) {
            obj_dL['invoice_number'] = data?.originalInvoice;
            obj_dL['amount'] = data?.payTxtAmnt;
          }
        }
        else if (stepName == 'confirmation') {
          obj_dL['step_name'] = 'Confirmation';
          obj_dL['step_number'] = "3";
          if (data?.reference) {
            obj_dL['invoice_number'] = data?.reference;
            obj_dL['amount'] = data?.invoice_amount;
          }
        }
        if (eventSubType.includes('error'))
          obj_dL['error_type'] = level === 'tab' ? 'Please correct the errors below' : 'Error'

        // for (var i = 0; i < _win.dataLayer.length; i++) {
        //   var event = _win.dataLayer[i];
        //   if (event.event == eventSubType) {
        //     _win.dataLayer.splice(i, 1);
        //   }
        // }
        break;
      }

      case "payByCredit_FormEvent": {
        obj_dL = {
          "interaction_type": "form",
          "length": "3",
          "name": "make a payment - pay by credit memo",
        }
        obj_dL["event"] = eventSubType;
        if (stepName == 'credit') {
          obj_dL['step_name'] = 'Credit';
          obj_dL['step_number'] = "1";
          if (data?.originalInvoice) {
            obj_dL['invoice_number'] = data?.originalInvoice;
            obj_dL['amount'] = '$' + data?.amount;
          }
        } else if (stepName == 'review') {
          obj_dL['step_name'] = 'Review';
          obj_dL['step_number'] = "2";
          if (data?.originalInvoice) {
            obj_dL['invoice_number'] = data?.originalInvoice;
            obj_dL['amount'] = '$' + data?.amount;
            obj_dL['invoice_balance'] = '$' + data?.invoiceBal;
          }
        }
        else if (stepName == 'confirmation') {
          obj_dL['step_name'] = 'Confirmation';
          obj_dL['step_number'] = "3";
          if (data?.originalInvoice) {
            obj_dL['invoice_number'] = data?.originalInvoice;
            obj_dL['amount'] = data?.invAmt;
            obj_dL['status'] = data?.msg;
            obj_dL['invoice_balance'] = data?.invBal;
          }
        }
        if (eventSubType.includes('error'))
          obj_dL['error_type'] = level === 'tab' ? 'Please correct the errors below' : 'Error'

        // for (var i = 0; i < _win.dataLayer.length; i++) {
        //   var event = _win.dataLayer[i];
        //   if (event.event == eventSubType) {
        //     _win.dataLayer.splice(i, 1);
        //   }
        // }
        break;
      }

      case "payNow_FormEvent": {
        obj_dL = {
          "interaction_type": "form",
          "length": "3",
          "name": "make a payment - pay now",
        }
        obj_dL["event"] = eventSubType;
        if (stepName == 'payment') {
          obj_dL['step_name'] = 'Payment';
          obj_dL['step_number'] = "1";
          if (data?.originalInvoice) {
            obj_dL['invoice_number'] = data?.originalInvoice;
            obj_dL['amount'] = '$' + data?.payTxtAmnt;
            //obj_dL['invoice_balance'] = data?.paymentAmnt;
          }
        } else if (stepName == 'review') {
          obj_dL['step_name'] = 'Review';
          obj_dL['step_number'] = "2";
          if (data?.originalInvoice) {
            obj_dL['invoice_number'] = data?.originalInvoice;
            obj_dL['amount'] = '$' + data?.payTxtAmnt;
          }
        }
        else if (stepName == 'confirmation') {
          obj_dL['step_name'] = 'Confirmation';
          obj_dL['step_number'] = "3";
          if (data?.originalInvoice) {
            obj_dL['invoice_number'] = data?.originalInvoice;
            obj_dL['amount'] = '$' + data?.payAmount;
          }
        }
        if (eventSubType.includes('error'))
          obj_dL['error_type'] = level === 'tab' ? 'Please correct the errors below' : 'Error'

        // for (var i = 0; i < _win.dataLayer.length; i++) {
        //   var event = _win.dataLayer[i];
        //   if (event.event == eventSubType) {
        //     _win.dataLayer.splice(i, 1);
        //   }
        // }
        break;
      }

      case "schedulePayment_FormEvent": {
        obj_dL = {
          "interaction_type": "form",
          "length": "1",
          "name": "make a payment - " + locs + " schedule payment",
          "step_name": locs + " schedule payment",
          "step_number": "1"
        }
        obj_dL["event"] = eventSubType;
        if (data?.originalInvoice) {
          obj_dL["invoice_number"] = data?.originalInvoice;
          obj_dL["amount"] = '$' + data?.paymentAmnt;
        }
        if (eventSubType === 'form_submit') {
          if (data?.status === 'S') {
            obj_dL["status"] = data?.status;
            obj_dL["status_msg"] = data?.statusMsg;
            obj_dL["payment_term"] = data?.paymentTerm;
            obj_dL["customer"] = data?.customer;
            obj_dL["documentno"] = data?.documentno;
            obj_dL["authnum"] = data?.authnum;
            obj_dL["shipto"] = data?.shipto;
            obj_dL["oldPaymentTerm"] = data?.oldPaymentTerm;
            obj_dL["item"] = data?.item
          } else {
            obj_dL["status"] = data?.status;
            obj_dL["status_msg"] = data?.statusMsg;
          }
        }

        if (eventSubType.includes('error'))
          obj_dL['error_type'] = level === 'tab' ? 'Please correct the errors below' : 'Error'

        for (var i = 0; i < _win.dataLayer.length; i++) {
          var event = _win.dataLayer[i];
          if (event.event == eventSubType) {
            _win.dataLayer.splice(i, 1);
          }
        }
        break;
      }

      case "addCard_FormEvent": {
        if (data === undefined) {
          data = 'card';
        } else if (data === 'account') {
          data = 'checking account';
        }
        obj_dL = {
          "interaction_type": "form",
          "length": "1",
          "name": "make a payment - add " + data,
          "step_name": "add " + data,
          "step_number": "1"
        }
        obj_dL["event"] = eventSubType;

        if (eventSubType.includes('error'))
          obj_dL['error_type'] = level === 'tab' ? 'Please correct the errors below' : 'Error'

        for (var i = 0; i < _win.dataLayer.length; i++) {
          var event = _win.dataLayer[i];
          if (event.event == eventSubType) {
            _win.dataLayer.splice(i, 1);
          }
        }
        break;
      }

      case "banner_link_clicked": {
        obj_dL = {
          "event": "select_promotion",
          "interaction_type": "ecommerce",
          "promotion_name": data.promotion_name,
          "creative_slot": data.creative_slot
        }
        break;
      }

      case "banner_displayed": {
        obj_dL = {
          "event": "view_promotion",
          "interaction_type": "ecommerce",
          "promotion_name": data.promotion_name,
          "creative_slot": data.creative_slot
        }
        break;
      }

      case 'viewDocument_OfferEvent': {
        obj_dL = {
          "event": "view_document",
          "interaction_type": "form",
          name: data.document_name
        }
        break;
      }

      case 'downloadDocument_OfferEvent': {
        obj_dL = {
          "event": "download_document",
          "interaction_type": "form",
          name: data.document_name
        }
        break;
      }

      case 'offerForm_FormEvent': {
        obj_dL = {
          event: eventSubType,
          interaction_type: 'form',
          name: 'Acceptance of offer',
        };

        if (eventSubType === 'form_submit') {
          obj_dL.selected_offer = data.selected_offer;
        }
        if (eventSubType === 'form_error') {
          obj_dL.error_type = data.error_type;
        }
        break;
      }
    }
    this.logPageView(obj_dL);
  }
}